import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

const _default_lang = 'en';
const _languages = ['en', 'tc'];

const i18n = new VueI18n({
    locale: _default_lang,
    fallbackLocale: _default_lang,
    messages: {}
});

export const languages = _languages
export const default_lang = _default_lang
export default i18n